/* Falling sakura petals for image-hero (setting "Falling sakura petals").
   Petals are painted once into sprites (fold, shade, light, curled edge) and drawn as images each frame.
   Root: .image-hero[data-petals] with data-repel, data-petal-scale, data-petal-count, data-petal-count-mobile;
   inside: .image-hero__image-container, canvas.image-hero__petals, .image-hero__text-container-wrapper. */
(function () {
  'use strict';

  // Respect the system 'reduce motion' setting
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ----------------------------------------------------------------------
     1. Paint a petal into a sprite
     ---------------------------------------------------------------------- */

  var supportsFilter = (function () {
    var probe = document.createElement('canvas').getContext('2d');
    if (!probe) return false;
    probe.filter = 'blur(2px)';
    return probe.filter === 'blur(2px)';
  })();

  function blur(ctx, px) {
    ctx.filter = supportsFilter ? 'blur(' + px + 'px)' : 'none';
  }

  // Outline: a drop with a pointed base; curve = how far it bends sideways
  function outline(ctx, w, h, curve) {
    var cx = w * 0.5;
    var bend = w * 0.2 * curve;

    ctx.beginPath();
    ctx.moveTo(cx + bend, h * 0.98);
    ctx.bezierCurveTo(cx - w * 0.24 + bend * 0.4, h * 0.84, cx - w * 0.47, h * 0.58, cx - w * 0.43, h * 0.32);
    ctx.bezierCurveTo(cx - w * 0.4, h * 0.13, cx - w * 0.22, h * 0.02, cx - w * 0.04, h * 0.045);
    ctx.quadraticCurveTo(cx + w * 0.08, h * 0.06, cx + w * 0.16, h * 0.1);
    ctx.bezierCurveTo(cx + w * 0.38, h * 0.19, cx + w * 0.45, h * 0.42, cx + w * 0.39, h * 0.62);
    ctx.bezierCurveTo(cx + w * 0.35, h * 0.79, cx + w * 0.26, h * 0.9, cx + bend, h * 0.98);
    ctx.closePath();
  }

  function creasePath(ctx, w, h, curve, offset) {
    var cx = w * 0.5 + (offset || 0);
    var bend = w * 0.16 * curve;
    ctx.beginPath();
    ctx.moveTo(cx + bend * 0.8, h * 0.95);
    ctx.quadraticCurveTo(cx - w * 0.02, h * 0.5, cx - w * 0.24, h * 0.12);
  }

  function renderSprite(size, curve, pale, flip) {
    var canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    var ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    var w = size * 0.86;
    var h = size * 0.94;

    ctx.save();
    ctx.translate((size - w) / 2, (size - h) / 2);

    outline(ctx, w, h, curve);
    ctx.save();
    ctx.clip();

    // light centre, deeper edge: reads as volume
    var base = ctx.createRadialGradient(w * 0.44, h * 0.52, w * 0.04, w * 0.5, h * 0.5, w * 0.62);
    base.addColorStop(0, '#fffdfe');
    base.addColorStop(0.34, pale ? '#fdeaf0' : '#fcdde6');
    base.addColorStop(0.72, pale ? '#f7c8d6' : '#f3adc2');
    base.addColorStop(1, pale ? '#f0b0c4' : '#e88faa');
    ctx.fillStyle = base;
    ctx.fillRect(0, 0, w, h);

    // the base is always deeper than the body
    var root = ctx.createLinearGradient(0, h, 0, h * 0.55);
    root.addColorStop(0, pale ? 'rgba(233, 150, 174, 0.62)' : 'rgba(222, 124, 154, 0.7)');
    root.addColorStop(1, 'rgba(255, 255, 255, 0)');
    ctx.fillStyle = root;
    ctx.fillRect(0, 0, w, h);

    var dir = flip ? -1 : 1;

    // shade
    var shade = ctx.createLinearGradient(w * (0.5 - 0.42 * dir), 0, w * (0.5 + 0.45 * dir), 0);
    shade.addColorStop(0, 'rgba(196, 112, 140, 0.42)');
    shade.addColorStop(0.34, 'rgba(214, 150, 172, 0.14)');
    shade.addColorStop(0.55, 'rgba(255, 255, 255, 0)');
    ctx.fillStyle = shade;
    ctx.fillRect(0, 0, w, h);

    // light
    blur(ctx, size * 0.06);
    var glow = ctx.createLinearGradient(w * (0.5 + 0.05 * dir), h * 0.9, w * (0.5 + 0.55 * dir), h * 0.1);
    glow.addColorStop(0, 'rgba(255, 255, 255, 0)');
    glow.addColorStop(0.45, 'rgba(255, 255, 255, 0.62)');
    glow.addColorStop(1, 'rgba(255, 255, 255, 0)');
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, w, h);
    ctx.filter = 'none';

    // fold: a dark line with a light one beside it
    blur(ctx, size * 0.012);
    ctx.lineCap = 'round';
    creasePath(ctx, w, h, curve, -w * 0.012);
    ctx.strokeStyle = 'rgba(188, 106, 134, 0.3)';
    ctx.lineWidth = size * 0.016;
    ctx.stroke();
    creasePath(ctx, w, h, curve, w * 0.02);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.72)';
    ctx.lineWidth = size * 0.02;
    ctx.stroke();
    ctx.filter = 'none';

    // side veins
    blur(ctx, size * 0.008);
    ctx.strokeStyle = 'rgba(198, 128, 152, 0.16)';
    ctx.lineWidth = size * 0.007;
    var fan = [-0.3, -0.16, 0.14, 0.28];
    for (var i = 0; i < fan.length; i++) {
      ctx.beginPath();
      ctx.moveTo(w * 0.5, h * 0.92);
      ctx.quadraticCurveTo(w * (0.5 + fan[i] * 0.5), h * 0.55, w * (0.5 + fan[i]), h * 0.18);
      ctx.stroke();
    }
    ctx.filter = 'none';

    // curled edge
    blur(ctx, size * 0.02);
    ctx.beginPath();
    ctx.moveTo(w * (0.5 + 0.3 * dir), h * 0.06);
    ctx.quadraticCurveTo(w * (0.5 + 0.48 * dir), h * 0.22, w * (0.5 + 0.4 * dir), h * 0.46);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.68)';
    ctx.lineWidth = size * 0.045;
    ctx.stroke();
    ctx.filter = 'none';

    ctx.restore();

    // rim
    outline(ctx, w, h, curve);
    ctx.strokeStyle = pale ? 'rgba(230, 160, 182, 0.5)' : 'rgba(222, 134, 162, 0.62)';
    ctx.lineWidth = size * 0.008;
    ctx.stroke();

    ctx.restore();
    return canvas;
  }

  // Five variations (bend, depth, side) so the stream never looks stamped; painted once per page.
  var spriteCache = {};
  function getSprites(size) {
    if (!spriteCache[size]) {
      spriteCache[size] = [
        renderSprite(size, 0.75, false, false),
        renderSprite(size, 0.35, false, false),
        renderSprite(size, 0.6, true, false),
        renderSprite(size, 0.5, false, true),
        renderSprite(size, 0.85, true, true)
      ];
    }
    return spriteCache[size];
  }

  // Pre-blurred shadow silhouettes: same look as per-frame shadowBlur, drawn once.
  // shadowBlur is in canvas pixels (not CSS), hence the division by dpr.
  function getShadows(sprites, dpr) {
    return sprites.map(function (sp) {
      var s = sp.width;
      var blurPx = (0.18 * s) / dpr;
      var pad = Math.ceil(blurPx * 2) + 2;
      var c = document.createElement('canvas');
      c.width = c.height = s + pad * 2;
      var x = c.getContext('2d');
      x.shadowColor = 'rgb(70, 30, 45)';
      x.shadowBlur = blurPx;
      x.shadowOffsetX = c.width;
      x.drawImage(sp, pad - c.width, pad, s, s);
      return { canvas: c, k: c.width / s };
    });
  }

  /* ----------------------------------------------------------------------
     2. Animation
     ---------------------------------------------------------------------- */

  function init(hero) {
    var canvas = hero.querySelector('.image-hero__petals');
    if (!canvas || !canvas.getContext) return;

    var ctx = canvas.getContext('2d');
    var media = hero.querySelector('.image-hero__image-container');
    var text = hero.querySelector('.image-hero__text-container-wrapper');
    var repel = hero.hasAttribute('data-repel');
    var coarse = window.matchMedia('(pointer: coarse)').matches;

    // Smaller and slower on phones: big petals on a narrow screen read as confetti
    var scale = parseFloat(hero.dataset.petalScale) || 1;
    if (coarse) scale *= 0.6;
    var speedK = coarse ? 0.85 : 1;

    var count = parseInt(coarse ? hero.dataset.petalCountMobile : hero.dataset.petalCount, 10);
    if (!count || count < 1) count = coarse ? 20 : 30;

    // Sprite sized for retina without wasting memory
    var sprites = getSprites(coarse ? 144 : 224);

    var petals = [];
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var shadows = getShadows(sprites, dpr);
    var point = { x: -9999, y: -9999, active: false };
    var w = 0;
    var h = 0;
    var running = false;
    var raf = null;

    function makePetal(seeded) {
      var depth = Math.random(); // 0 far, 1 near
      var size = (12 + depth * 26) * scale;

      return {
        sprite: (Math.random() * sprites.length) | 0,
        x: Math.random() * w,
        y: seeded ? Math.random() * h : -size * 2 - Math.random() * h * 0.4,
        depth: depth,
        size: size,
        vy: (0.22 + depth * 0.62) * speedK,
        swayAmp: 12 + Math.random() * 30,
        swayPhase: Math.random() * Math.PI * 2,
        swaySpeed: 0.006 + Math.random() * 0.01,
        spin: (Math.random() - 0.5) * 0.014,
        rot: Math.random() * Math.PI * 2,
        flip: Math.random() * Math.PI * 2,
        flipSpeed: 0.009 + Math.random() * 0.017,
        alpha: 0.6 + depth * 0.38,
        ox: 0,
        oy: 0 // push from the cursor, fades by itself
      };
    }

    function resize() {
      var rect = hero.getBoundingClientRect();
      w = rect.width;
      h = rect.height;
      if (!w || !h) return;

      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      while (petals.length < count) petals.push(makePetal(true));
      petals.length = count;
    }

    // dt: frames of 60 Hz since the last draw, so 120 Hz screens do not double the speed
    function draw(dt) {
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < petals.length; i++) {
        var p = petals[i];

        p.y += p.vy * dt;
        p.swayPhase += p.swaySpeed * dt;
        p.rot += p.spin * dt;
        p.flip += p.flipSpeed * dt;

        var x = p.x + Math.sin(p.swayPhase) * p.swayAmp;
        var y = p.y;

        if (repel && point.active) {
          var dx = x - point.x;
          var dy = y - point.y;
          var dist = Math.sqrt(dx * dx + dy * dy) || 1;
          var r = coarse ? 110 : 165; // smaller radius on narrow screens

          if (dist < r) {
            var force = (1 - dist / r) * 46 * (0.45 + p.depth);
            p.ox += ((dx / dist) * force - p.ox) * 0.14;
            p.oy += ((dy / dist) * force - p.oy) * 0.14;
            p.rot += 0.02 * (dx > 0 ? 1 : -1);
          }
        }

        p.ox *= 0.94;
        p.oy *= 0.94;
        x += p.ox;
        y += p.oy;

        if (y - p.size * 2 > h) {
          petals[i] = makePetal(false);
          continue;
        }

        // horizontal squeeze = the petal flips in the air
        var sx = Math.max(0.14, Math.abs(Math.cos(p.flip)));
        var cos = Math.cos(p.rot) * dpr;
        var sin = Math.sin(p.rot) * dpr;
        var half = p.size / 2;
        var sh = shadows[p.sprite];
        var shHalf = half * sh.k;

        // shadow: offset straight down in screen space, like shadowOffsetY
        ctx.setTransform(cos * sx, sin * sx, -sin, cos, x * dpr, (y + (p.size * 0.05) / dpr) * dpr);
        ctx.globalAlpha = p.alpha * (0.18 + p.depth * 0.16);
        ctx.drawImage(sh.canvas, -shHalf, -shHalf, shHalf * 2, shHalf * 2);

        ctx.setTransform(cos * sx, sin * sx, -sin, cos, x * dpr, y * dpr);
        ctx.globalAlpha = p.alpha;
        ctx.drawImage(sprites[p.sprite], -half, -half, p.size, p.size);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalAlpha = 1;
    }

    var last = 0;
    function frame(now) {
      var dt = last && now ? Math.min(3, (now - last) / 16.667) : 1;
      last = now || 0;
      draw(dt);
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (!running) {
        running = true;
        frame();
      }
    }

    function stop() {
      if (running) {
        running = false;
        last = 0;
        cancelAnimationFrame(raf);
      }
    }

    // Animate only while the banner is on screen
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      },
      { threshold: 0.05 }
    ).observe(hero);

    // The section is sized in vh: recalculate on resize
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 150);
    });

    resize();

    if (!repel) return;

    /* --- desktop: background and text follow the cursor, petals make way --- */
    hero.addEventListener('pointermove', function (ev) {
      var rect = hero.getBoundingClientRect();
      point.x = ev.clientX - rect.left;
      point.y = ev.clientY - rect.top;
      point.active = true;

      if (coarse) return; // phones: petals react to the finger, the background stays

      var nx = (point.x / rect.width - 0.5) * 2;
      var ny = (point.y / rect.height - 0.5) * 2;
      if (media) media.style.transform = 'translate3d(' + -nx * 16 + 'px,' + -ny * 12 + 'px,0)';
      if (text) text.style.transform = 'translate3d(' + nx * 9 + 'px,' + ny * 7 + 'px,0)';
    });

    hero.addEventListener('pointerleave', function () {
      point.active = false;
      point.x = -9999;
      point.y = -9999;
      if (media) media.style.transform = '';
      if (text) text.style.transform = '';
    });
  }

  function boot() {
    document.querySelectorAll('.image-hero[data-petals]').forEach(init);
  }

  // Start after the page has loaded and the browser is idle, so petals never compete with the first paint
  function later() {
    if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 1500 });
    else setTimeout(boot, 200);
  }

  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });

  // The theme editor rebuilds the section on setting changes: start again
  document.addEventListener('shopify:section:load', function (ev) {
    var hero = ev.target.querySelector('.image-hero[data-petals]');
    if (hero) init(hero);
  });
})();
